import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { DropdownMenuItem } from '@components/basics/Dropdowns/GlobalDropdown';
import { MoreDropdown } from '@components/basics/Dropdowns/MoreDropdown';
import { CommentModalV2 } from '@components/modals/CommentV2';
import { ModalContext, ModalType } from '@context/modal';

type CommentActionsProps = {
  releaseId: string;
  nftId: string;
};

export const CommentAction = ({ releaseId, nftId }: CommentActionsProps) => {
  const { openModal } = ModalContext.useContainer();

  const onEdit = () => {
    openModal(ModalType.COMMENT_MODAL_V2, {
      body: <CommentModalV2 releaseId={releaseId} editNftId={nftId} />,
    });
  };

  return (
    <div className="flex items-center">
      <MoreDropdown>
        <DropdownMenuItem onClick={onEdit}>
          <FontAwesomeIcon icon={faEdit} className="mr-1" />
          Edit
        </DropdownMenuItem>
      </MoreDropdown>
    </div>
  );
};
